import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'

export function getEntityKey(entityType: EntityType, entityId: string): string {
  return `${entityType}-${entityId}`
}
